// Configuration centrale du site
// Remplacez les URLs de webhook par vos vrais endpoints (n8n, Make, Zapier, etc.)

const config = {
  // Webhook pour le formulaire de contact (POST JSON)
  // Exemple n8n : https://n8n.example.com/webhook/contact
  contactWebhook: process.env.REACT_APP_CONTACT_WEBHOOK || '',

  // Webhook pour la newsletter (POST { email })
  newsletterWebhook: process.env.REACT_APP_NEWSLETTER_WEBHOOK || '',

  // Webhook pour les devis TECHMILL
  techmillWebhook: process.env.REACT_APP_TECHMILL_WEBHOOK || '',

  // Webhook pour le chatbot IA (POST { message, history, language })
  // Le webhook doit retourner { reply: "..." }
  chatbotWebhook: process.env.REACT_APP_CHATBOT_WEBHOOK || '',

  // Analytics — laisser vide si non utilisé
  // Google Analytics 4 (ex: G-XXXXXXXXXX)
  gaId: process.env.REACT_APP_GA_ID || '',
  // Plausible (ex: ai-dynamics.fr)
  plausibleDomain: process.env.REACT_APP_PLAUSIBLE_DOMAIN || '',

  // Email de contact (fallback si pas de webhook)
  contactEmail: 'contact@ai-dynamics.fr',

  // Numéro WhatsApp (format international sans +)
  whatsappPhone: '33647545001'
};

export default config;
